import {
  RECEIVE_DAILY_CONDITIONS,
  REQUEST_DAILY_CONDITIONS,
  REQUEST_HOURLY_CONDITION,
  RECEIVE_HOURLY_CONDITIONS,
  RECEIVE_CURRENT_CONDITIONS,
  REQUEST_CURRENT_CONDITIONS,
  FAILURE_WEATHER_CONDITIONS,
  REQUEST_CURRENT_CONDITIONS_BY_LOCATION,
  REQUEST_HOURLY_CONDITION_BY_LOCATION,
  REQUEST_DAILY_CONDITIONS_BY_LOCATION,
} from '../constants/actionTypes';

export function receiveCurrentConditions(currentConditions) {
  return {
    type: RECEIVE_CURRENT_CONDITIONS,
    currentConditions,
  };
}

export function receiveHourlyConditions(hourlyConditions) {
  return {
    type: RECEIVE_HOURLY_CONDITIONS,
    hourlyConditions,
  };
}

export function receiveDailyConditions(dailyConditions) {
  return {
    type: RECEIVE_DAILY_CONDITIONS,
    dailyConditions,
  };
}

export function getCurrentConditions(field) {
  return {
    type: REQUEST_CURRENT_CONDITIONS,
    field,
  };
}

export function getCurrentConditionsByLocation(field) {
  return {
    type: REQUEST_CURRENT_CONDITIONS_BY_LOCATION,
    field
  };
}

export function getHourlyConditions(field) {
  return {
    type: REQUEST_HOURLY_CONDITION,
    field,
  };
}

export function getHourlyConditionsByLocation(field) {
  return {
    type: REQUEST_HOURLY_CONDITION_BY_LOCATION,
    field
  };
}

export function getDailyConditions(field) {
  return {
    type: REQUEST_DAILY_CONDITIONS,
    field,
  };
}

export function getDailyConditionsByLocation(field) {
  return {
    type: REQUEST_DAILY_CONDITIONS_BY_LOCATION,
    field
  };
}

export function failureWeatherConditions(error) {
  return {
    type: FAILURE_WEATHER_CONDITIONS,
    error,
  };
}
